export enum Role {
  Moderator = 'MODERATOR', // Moderator = 'ROLE_MODERATOR'
  Partner = 'PARTNER_USER',
}

export const RoleName = {
  [Role.Moderator]: 'Модератор',
  [Role.Partner]: 'Пользователь',
};